<template>
  <b-container fluid>
    <b-card>
      <modal name="edit-user" @before-close="editModalClosed" width="60%" height="auto" :scrollable="true" :adaptive="true">
        <UserForm :edit-mode="true" :user="this.currentUser" :title="$t('posUser.edit-title')"></UserForm>
      </modal>
      <b-card-body>
       <!-- <b-row style="padding-bottom: 10px;">
          <b-col cols="4" align-h="end" class="pull-right">
            <input type="search" class="form-control input-sm" :placeholder="$t('userList.search-placeholder')" v-model="searchQuery" aria-controls="datatables">
          </b-col>
        </b-row> -->
        <div class="grid-container">
          <div class="grid-item grid-item-1">
            <input type="search" class="form-control input-sm" v-model="idS" :placeholder="$t('agentList.id')"  aria-controls="datatables" >
          </div>
          <div class="grid-item grid-item-2 ">
            <input type="search" class="form-control input-sm" :placeholder="$t('agentList.agent-tax-id')" v-model="agentTaxIdS" aria-controls="datatables"  >
          </div>

          <div class="grid-item grid-item-3 ">
            <input type="search" class="form-control input-sm" :placeholder="$t('agentList.amount')" v-model="amountS" aria-controls="datatables">
          </div>

          <div class="grid-item grid-item-4 ">
            <input type="search" class="form-control input-sm" :placeholder="$t('agentList.reference')" v-model="referenceS" aria-controls="datatables"  >
          </div>
          <div class="grid-item grid-item-5 " >
            <input type="search" class="form-control input-sm" :placeholder="$t('agentList.destination-account-number')" v-model="destinationAccountNumberS" aria-controls="datatables"  >
          </div>

          <div class="grid-item grid-item-6 ">
            <input type="search" class="form-control input-sm" :placeholder="$t('agentList.purpose')" v-model="purposeS" aria-controls="datatables"  >
          </div>
          <div class="grid-item grid-item-7">
            <input type="search" class="form-control input-sm" :placeholder="$t('agentList.received-time')" v-model="receivedTimeS" aria-controls="datatables" >
          </div>
          <div class="grid-item grid-item-8">
            <input type="search" class="form-control input-sm" :placeholder="$t('agentList.processed-time')" v-model="processedTimeS" aria-controls="datatables" >
          </div>
     <!-- PROCESSIRANA KOLIČINA
          <div class="grid-item grid-item-9">
            <input type="search" class="form-control input-sm" :placeholder="$t('agentList.processed-amount-short')" v-model="processedAmountS" aria-controls="datatables" >
          </div>
          -->
          <div class="grid-item grid-item-10">
            <input type="search" class="form-control input-sm" :placeholder="$t('agentList.processed-fee-short')" v-model="processedFeeS" aria-controls="datatables" >
          </div>

          <div class="grid-item grid-item-11 ">
            <button class="btn btn-info" @click="clearSearch">{{$t('agentList.clear')}}</button>
          </div>
        </div>

        <b-row>
          <el-table class="table-striped"
                    v-if="queriedData"
                    :data="queriedData"
                    @sort-change = "sortChange"
                    border
                    style="width: 100%;"
                    ref="table">
            <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :formatter="column.formatter"
                :sortable="column.sortable">
            </el-table-column>
            <el-table-column :min-width="60" >
               <template >
                <a :title="$t('userList.delete-user')"  class="btn btn-simple btn-lg btn-icon" disabled hidden><i class="ti-trash"  ></i></a>
              </template>
            </el-table-column>
          </el-table>
        </b-row>
        <b-row style="padding-top: 10px;">
          <b-col md="auto">
            <el-select
                style="width: 80px; margin-left: 20px;"
                class="select-default"
                v-model="pagination.perPage"
                placeholder="Per page">
              <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </b-col>
          <b-col>
            <b-button type="button" @click="search" class="btn btn-info">
              {{ $t('userList.refresh') }}
            </b-button>
          </b-col>
          <b-col>
            <p-pagination class="pull-right"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="pagination.total">
            </p-pagination>
          </b-col>
          <b-col>
            <b-button type="button" @click="exportExcel" class="btn btn-fill btn-primary">
              {{ $t('agentList.export-excel') }}
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-container>
</template>

<style>
.el-table .cell {
word-break: normal !important;}

.grid-container {

  display: grid;
  grid-template-columns: 0.75fr 2fr 1.5fr 1.5fr 1.5fr 1.25fr 2fr 2fr 1.5fr 1fr;
  margin-bottom: 1em;
  margin-top: 0.5em;
}

.grid-item-2 {
  margin-left:4.3em;
  margin-right: -1em;

}
.grid-item-3 {
  margin-left:1.6em;
}
.grid-item-4 {
  margin-left:2.2em;
}
.grid-item-5 {
  margin-left:2.5em;
  margin-right: -2em;
}
.grid-item-6 {
  margin-left:3em;
  margin-right: -2em;
}
.grid-item-7 {
  margin-left:5em;
  margin-right: -1.3em;
}
.grid-item-8 {
  margin-left:2em;
  margin-right: 0.7em;
}
.grid-item-9 {
  margin-left:0em;
  margin-right: 1em;

}
.grid-item-10{
  margin-right: 3em;
}
.grid-item-11{
  margin-left:0.5em;
}

</style>

<script>
import Vue from 'vue'
import {filter} from '../data/usersFilter'
import utils from "../util/utils";
import {Option, Select, Table, TableColumn} from "element-ui";
import PPagination from 'frontend_common/src/components/UIComponents/Pagination.vue';
import Constants from "frontend_common/src/constants/globalConstants";
import moment from "moment";
import swal from 'sweetalert2'
import UserForm from "./UserForm";

Vue.use(Table);
Vue.use(TableColumn);

//access-control
export default {
  name: "List",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    PPagination,
    UserForm
  },
  data() {
    return {
      searchQuery: '',
      userData: null,
      currentUser: null,
      emptySearch: true,
      idS:'',
      agentTaxIdS:'',
      amountS:'',
      referenceS:'',
      destinationAccountNumberS:'',
      purposeS:'',
      receivedTimeS:'',
      processedTimeS:'',
      processedAmountS:'',
      processedFeeS:'',
      tableColumns: [
        {
          prop: 'id',
          label: this.$t('agentList.id'),
          sortable: 'custom',
        },
        {
          prop: 'agentTaxId',
          label: this.$t('agentList.agent-tax-id'),
          sortable: 'custom'
        },
        {
          prop: 'amount',
          label: this.$t('agentList.amount'),
          sortable: 'custom',
        },
        {
          prop: 'reference',
          label: this.$t('agentList.reference'),
          sortable: 'custom',
        },
        {
          prop: 'destinationAccountNumber',
          label: this.$t('agentList.destination-account-number'),
          sortable: 'custom',
        },
        {
          prop: 'purpose',
          label: this.$t('agentList.purpose'),
          sortable: 'custom',
        },
        {
          prop: 'receivedTime',
          label: this.$t('agentList.received-time'),
          sortable: 'custom',
          formatter: this.receivedTimeFormatter
        },
        {
          prop: 'processedTime',
          label: this.$t('agentList.processed-time'),
          sortable: 'custom',
          formatter: this.processedTimeFormatter
        },
   /*    PROCESIRANA KOLIČINA
    {
          prop: 'processedAmount',
          label: this.$t('agentList.processed-amount'),
          sortable: 'custom',
        },*/
        {
          prop: 'processedFee',
          label: this.$t('agentList.processed-fee'),
          sortable: 'custom',
        },
      ],
      pagination: {
        perPage: this.$store.getters.getPerPage,
        currentPage: 1,
        perPageOptions: [10, 25, 50],
        total: 0
      },
      tableData: [],
      sort: {prop: 'receivedTime', order: 'descending'},
      exportHeaders: ["ID", "Davčna številka agenta", "Znesek", "Referenca", "TRR", "Namen", "Datum vplačila", "Čas procesiranja", "Provizija (€)"],
      exportNames:  ["agentId","agentTaxId", "amountS", "reference", "destinationAccountNumber", "purpose", "receivedTime", "processedTime", "processedFee"],
      tableSearch:{},
      searchedData:{},
    }
  },
  methods: {
    // Mitja Barbo

    clearSearch(){
          this.idS='';
          this.agentTaxIdS='';
          this.amountS='';
          this.referenceS='';
          this.destinationAccountNumberS='';
          this.purposeS='';
          this.receivedTimeS='';
          this.processedTimeS='';
         // this.processedAmountS='';
          this.processedFeeS='';
    },

    updateOnStart() {
      for (let a of this.tableData) {
        a.amountS=a.amount.toString();
        a.amount=a.amount.toFixed(2);

        a.processedFee=parseFloat(a.processedFee).toFixed(2);


        let date = moment(a.receivedTime).format(Constants.DATE_FORMAT);
        a.receivedTimeS = date;
        let ptime = moment(a.processedTime).format(Constants.DATE_FORMAT);
        a.processedTimeS = ptime;
      }
      console.log(this.tableData)
      return this.tableData;
    },
    exportExcel(){
      let list =[]; //loop array
      const sheet =[] //end array
      //pridobivanje podatkov
      let tableData = []
      if(!this.emptySearch){
        tableData = this.searchedData
      }
      else {
        tableData = this.tableData.reverse()
      }
      tableData.forEach(dataset =>{ //building an array of arrays to later go through and build the XML file (exportExcelData)
        list=[];
        for (let variable in this.exportNames) { //export object variables
          let key = this.exportNames[variable];
          if(key === "receivedTime" || key === "processedTime"){
            let datum = new Date(dataset[key])
            datum = this.timeFormatter(datum)
            list.push(datum)
          }

          else{
            list.push(dataset[key])
          }
        }
        sheet.push(list);
      })
      this.export(sheet);
    },
    export(sheet){ //excel creating function
      let XLS = this.excelExportData(this.exportHeaders,sheet)
      var a = document.createElement("a");
      a.href = "data:application/vnd.ms-excel;base64," + btoa(unescape(encodeURIComponent(XLS)));
      a.download = "transfers.xls";
      document.body.appendChild(a);     // neded for Firefox; works without on Chrome
      a.click();
    },
    excelExportData(header,data){ // exporting data and building the XML file
      var TEMPLATE_HEADER = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n" +
          "<?mso-application progid=\"Excel.Sheet\"?>\n" +
          "<Workbook xmlns=\"urn:schemas-microsoft-com:office:spreadsheet\" xmlns:c=\"urn:schemas-microsoft-com:office:component:spreadsheet\" xmlns:html=\"http://www.w3.org/TR/REC-html40\" xmlns:o=\"urn:schemas-microsoft-com:office:office\" xmlns:ss=\"urn:schemas-microsoft-com:office:spreadsheet\" xmlns:x2=\"http://schemas.microsoft.com/office/excel/2003/xml\" xmlns:x=\"urn:schemas-microsoft-com:office:excel\" xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\">\n" +
          "<ss:Worksheet ss:Name=\"Sheet1\">\n" +
          "<Table>\n" +
          "";
      var TEMPLATE_FOOTER = "</Table>\n" +
          "</ss:Worksheet>\n" +
          "</Workbook>\n" +
          "";
      var xls = TEMPLATE_HEADER;
      xls += this.excelExportRow(header);
      data.forEach(object =>{
        xls += this.excelExportRow(object);
      });
      xls += TEMPLATE_FOOTER;
      return xls;
    },
    excelExportRow (data){ //exporting row data
      var row = "<Row>";
      data.forEach(element => {
        row += "<Cell><Data ss:Type=\"String\">";
        row += ("" + element);
        row += "</Data></Cell>";
      });
      row += "</Row>";
      return row;
    },
    timeFormatter (date) {
      return moment(date).format(Constants.DATE_FORMAT);
    },

    checkEmptySearch(){
      //eslint-disable-next-line
      for (const [key,value] of Object.entries(this.tableSearch)) {
        if(value!=null){
          this.emptySearch =false
          return
        }
      }
      this.emptySearch = true
    },
    checkSearch(){
      if(this.idS){
        this.tableSearch["id"]=this.idS
      }
      if(this.agentTaxIdS){
        this.tableSearch["agentTaxId"] = this.agentTaxIdS
      }
      if(this.amountS){
        this.tableSearch["amountS"] = this.amountS
      }
      if(this.referenceS){
        this.tableSearch["reference"] = this.referenceS
      }
      if(this.destinationAccountNumberS){
        this.tableSearch["destinationAccountNumber"] = this.destinationAccountNumberS
      }
      if(this.purposeS){
        this.tableSearch["purpose"] = this.purposeS
      }
      if(this.receivedTimeS){
        this.tableSearch["receivedTimeS"] = this.receivedTimeS
      }
      if(this.processedTimeS){
        this.tableSearch["processedTimeS"] = this.processedTimeS
      }
      if(this.processedFeeS){
        this.tableSearch["processedFee"] = this.processedFeeS
      }
      return this.tableSearch
    },

    search() {
      let query = JSON.parse(JSON.stringify(filter));
      this.$store.dispatch('transferQuery', query)
          .then((response) => {
            this.tableData = response.data;
            this.tableData = this.updateOnStart();
          })
          .catch(error => {
            this.$store.commit('setError', error);
          });
    },
    sortChange(column) {
      if (column.prop)
        this.sort = {prop: column.prop, order: column.order}
      else
        this.sort = null;
    },
    dynamicSort(property) {
      let sortOrder = 1;
      if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }

      return function (a,b) {
        let valueA;
        let valueB;

        let propertyA = utils.methods.getProperty(property, a);
        let propertyB = utils.methods.getProperty(property, b);
        if (propertyA === null || typeof propertyA === 'undefined') propertyA = "";
        if (propertyB === null || typeof propertyB === 'undefined') propertyB = "";


        if(property ==="amount" || property==="processedAmount" || property === "processedFee"){
          valueA = parseFloat(propertyA);
          valueB = parseFloat(propertyB);

        }
        else{
          valueA = propertyA.toString().toUpperCase();
          valueB = propertyB.toString().toUpperCase();
          }


        if(sortOrder === -1) {
          return ((valueA == valueB) ? 0 : ((valueA < valueB) ? 1 : -1));
        } else {
          return ((valueA == valueB) ? 0 : ((valueA > valueB) ? 1 : -1));
        }
      }
    },
    processedTimeFormatter: function(row) {
      return moment(row.processedTime).format(Constants.DATE_FORMAT);
    },
    receivedTimeFormatter: function(row) {
      return moment(row.receivedTime).format(Constants.DATE_FORMAT);
    },
    deletePopup(userData) {
      this.userData = userData;
      swal.fire({
        title: this.$t('userList.delete-notification'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('userList.delete'),
        cancelButtonText: this.$t('userList.cancel'),
        confirmButtonClass: 'btn btn-danger btn-fill',
        cancelButtonClass: 'btn btn-success btn-fill',
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          this.deleteUser(this.userData);
        } else {
          this.userData = null;
        }
      })
    },
    deleteUser(userData) {
      let request = {
        user: userData
      };

      this.$store.dispatch('deleteUser', request)
          .then(() => {
            this.userData = null;
            swal.fire({
              title: this.$t('userList.delete-title'),
              text: this.$t('userList.delete-success'),
              confirmButtonClass: 'btn btn-success btn-fill',
              icon: 'success'
            }).then(() => {
              this.search();
            })
          })
          .catch(error => {
            this.userData = null;
            this.$store.commit('setError', error);
          });
    },
    editUser(userData) {
      // alert('Update user: ' + JSON.stringify(userData));
      this.currentUser = JSON.parse(JSON.stringify(userData));
      this.$modal.show('edit-user');
    },
    editModalClosed(event) {
      if(typeof(event) !== 'undefined' && typeof(event.params) !== 'undefined' && typeof(event.params.updated) !== 'undefined' && event.params.updated) {
        this.search();
      }
    },
  },
  computed: {
    users() {
      return this.$store.getters.getTransfers;
    },
    pagedData () {
      let sorted = this.tableData.slice(0);
      if (this.sort){
        const direction = this.sort.order === "ascending" ? "" : "-";
        sorted.sort(this.dynamicSort(`${direction}${this.sort.prop}`))
      }
      return sorted.slice(this.from, this.to)
    },
    queriedData () {
      this.checkSearch()
      this.checkEmptySearch()
      if (this.emptySearch) {
        this.pagination.total = this.tableData.length
        return this.pagedData
      }

      let sorted = this.tableData.slice(0);
      if (this.sort){
        const direction = this.sort.order === "ascending" ? "" : "-";
        sorted.sort(this.dynamicSort(`${direction}${this.sort.prop}`))
      }
      let searchQ = this.checkSearch()
      let temporary =  []
      let result = sorted
          .filter((row) => {
            let isIncluded = false

            for (const [key,value] of Object.entries(searchQ)) {
              //console.log(value)
              if(value == null){
                break
              }
              if (row[key] !== null && typeof (row[key]) !== 'undefined' && row[key].includes && row[key].includes(value)) {
                isIncluded = true
              }
              else{
                isIncluded = false
                break
              }
            }

            if(isIncluded){
              temporary.push(row)
            }
            return isIncluded
          })
      this.searchedData= temporary;
      this.tableSearch =
          {
          }
      this.emptySearch=false
      this.pagination.total = result.length
      return result.slice(this.from, this.to)
    },
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      this.pagination.total = this.tableData.length
      return this.tableData.length
    }
  },
  mounted () {
    this.search();
  },
}
</script>

<style scoped>

</style>